module.exports = __webpack_public_path__ + "static/media/jessie-win.faa13643.png";